import React from 'react';
import { Modal } from "react-bootstrap";

const StandardFormModal = ({ title, body, showModal, onCloseModal, className }) => {
  return (
    <div>
      <Modal
        show={showModal}
        onHide={onCloseModal}
        className={className}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{body()}</Modal.Body>
      </Modal>
    </div>
  );
}
export default StandardFormModal;